import ResourcesPanel from './ResourcesPanel';

export default ResourcesPanel;
